<template>
  <div>
    <modal
      name="pricing_compare_modal"
      :width="'700px'"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      style="z-index:9999;"
    >
      <div class="modal_close_cont">
        <button
          @click="
            $modal.hide('pricing_compare_modal');
            this.highlight_feature = '';
          "
        ></button>
      </div>
      <PricingStrongerTogether :highlight_feature="highlight_feature" />
    </modal>
  </div>
</template>

<script>
import PricingStrongerTogether from "@/components/admin/PricingStrongerTogether.vue";

export default {
  components: {
    PricingStrongerTogether
  },
  data() {
    return {
      highlight_feature: ""
    };
  },
  mounted() {
    this.event_bus.$on("show-pricing-compare-modal", payload => {
      this.highlight_feature = payload;
      this.$modal.show("pricing_compare_modal");
    });
  }
};
</script>
